import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import CouplesTherapy from "@/pages/CouplesTherapy";
import About from "@/pages/About";
import Approach from "@/pages/Approach";
import Infidelity from "@/pages/Infidelity";
import PostRelationship from "@/pages/PostRelationship";
import Individual from "@/pages/Individual";
import TelehealthFaq from "@/pages/TelehealthFaq";
import Contact from "@/pages/Contact";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Testimonials from "@/pages/Testimonials";
import Espanol from "@/pages/Espanol";
import Separation from "@/pages/Separation";
import CouplesIntensive from "@/pages/CouplesIntensive";
import IntensiveGuide from "@/pages/IntensiveGuide";
import BookingConfirmed from "@/pages/BookingConfirmed";
import BusinessCard from "@/pages/BusinessCard";
import HeroPreview from "@/pages/HeroPreview";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const Layout = () => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    if (window.gtag) {
      window.gtag("event", "page_view", { page_title: document.title, page_location: window.location.href });
    }
  }, [pathname]);

  return (
    <div className="min-h-screen bg-cream-50">
      <div className="grain-overlay" />
      <ScrollToTop />
      {!isAdmin && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/couples-therapy" element={<CouplesTherapy />} />
        <Route path="/about-me" element={<About />} />
        <Route path="/my-approach" element={<Approach />} />
        <Route path="/infidelity-trust" element={<Infidelity />} />
        <Route path="/post-relationship-counseling" element={<PostRelationship />} />
        <Route path="/individual-therapy" element={<Individual />} />
        <Route path="/telehealth-faq" element={<TelehealthFaq />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/es" element={<Espanol />} />
        <Route path="/separation-counseling" element={<Separation />} />
        <Route path="/couples-therapy-intensive" element={<CouplesIntensive />} />
        <Route path="/intensive-guide" element={<IntensiveGuide />} />
        <Route path="/booking-confirmed" element={<BookingConfirmed />} />
        <Route path="/card" element={<BusinessCard />} />
        <Route path="/image-preview" element={<HeroPreview />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/contact-us" element={<Navigate to="/contact" replace />} />
        <Route path="/pricing" element={<Navigate to="/telehealth-faq" replace />} />
        <Route path="/about" element={<Navigate to="/about-me" replace />} />
        <Route path="/services" element={<Navigate to="/couples-therapy" replace />} />
        <Route path="/faq" element={<Navigate to="/telehealth-faq" replace />} />
        <Route path="/home" element={<Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {!isAdmin && <Footer />}
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}

export default App;
